// client/src/utils/routeArtworkPreload.js
//
// One route -> critical artwork map, shared by two callers:
//   * public/index.html, which reads the initial pathname during HTML parse and
//     preloads that route's tiles before the app bundle has even downloaded;
//   * navigation intent (hover / focus / pointer-down) inside the app, so an
//     INTERNAL navigation warms the destination's artwork instead of waiting for
//     the destination component to render and request it.
//
// Both paths emit the exact URL the tile will render, so the preload is reused
// rather than duplicated. Nothing is preloaded for routes not listed here, so
// unrelated routes pay nothing.
const ROUTE_ARTWORK = {
  "/genesis-hub": ["mediaplanner.v1.jpg", "campaignoptimization.v1.jpg", "authorize.v1.jpg", "billing.v1.jpg", "integrations.v1.jpg"],
};

export const normalizeArtworkRoute = (pathname) =>
  String(pathname || "").toLowerCase().trim().replace(/\/+$/, "") || "/";

const injected = new Set();

export function preloadRouteArtwork(pathname) {
  if (typeof document === "undefined") return;
  const names = ROUTE_ARTWORK[normalizeArtworkRoute(pathname)];
  if (!names) return;
  const base = process.env.PUBLIC_URL || "";
  names.forEach((name) => {
    const href = `${base}/tiles/${name}`;
    if (injected.has(href)) return;
    injected.add(href);
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = href;
    link.fetchPriority = "high";
    document.head.appendChild(link);
  });
}

export const artworkIntentHandlers = (pathname) => ({
  onMouseEnter: () => preloadRouteArtwork(pathname),
  onFocus: () => preloadRouteArtwork(pathname),
  onPointerDown: () => preloadRouteArtwork(pathname),
});
